module.exports = __webpack_public_path__ + "img/55_29.9a49de97.png";